(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.multiHeroCarousel = {
    attach: function (context) {
      const carousels = once('multiHeroCarousel', '.multi-hero-carousel-wrap', context);

      carousels.forEach(function (root) {
        const viewport = root.querySelector('.embla__viewport');
        if (!viewport) return;

        const autoplay = EmblaCarouselAutoplay({
          stopOnMouseEnter: false,
          stopOnInteraction: false
        });

        const embla = EmblaCarousel(viewport, {
          align: 'start',
          loop: true,
          dragFree: true,
          skipSnaps: true,
          containScroll: false
        });

        let animationId;
        const speed = -1;

        function autoScroll() {
          if (!embla) return;

          const engine = embla.internalEngine();
          engine.scrollBody.useBaseFriction();
          engine.scrollTo.distance(speed);

          animationId = requestAnimationFrame(autoScroll);
        }

        animationId = requestAnimationFrame(autoScroll);

        root.addEventListener('mouseenter', () => {
          cancelAnimationFrame(animationId);
        });

        root.addEventListener('mouseleave', () => {
          animationId = requestAnimationFrame(autoScroll);
        });


        root.addEventListener('focusin', () => autoplay.stop(), true);
        root.addEventListener('focusout', () => autoplay.play(), true);
      });
    }
  };
})(Drupal, once);
